<img [style.height]="size" [style.width]="size" src="assets/img/oval.svg" class="loading-icon-small" />